import { Link as RouterLink } from 'react-router-dom';
import { styled, css } from 'styled-components';
export const linkStyles = css `
  text-decoration: none;
  cursor: pointer;
  transition: color 150ms ease;

  &,
  &:visited {
    color: ${({ theme }) => theme.colors.link100};
  }

  &:hover,
  &:focus {
    color: ${({ theme }) => theme.colors.link120};
    text-decoration: none;
  }
`;
const Link = styled(RouterLink) `
  ${linkStyles}
`;
export const LinkSpan = styled.span `
  ${linkStyles}
`;
export default Link;
